import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../auth";
import { QueryKeys } from "../QueryKeys";
import { useApi } from "../useApi";

export const useFetchTermsAndConditionsStatus = () => {
  const { api } = useApi();
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: [QueryKeys.fetchTermsAndConditionsStatus],
    queryFn: () => api.patient.getTermsAcceptedStatus(),
    enabled: isAuthenticated,
  });
};
